export default defineNuxtRouteMiddleware(() => {
	// const route = useRoute()
	// const localePath = useLocalePath()
	// if (!route.query.token || !route.query.email) {
	// 	return navigateTo(localePath('login'))
	// }
})
